import { ExperimentClient } from './experimentClient';

export const experiment = new ExperimentClient();
